module.exports = "data:text/markdown;base64,IyMjIER5bmFtaWMgTGlzdAoKQSBsaXN0IHRoYXQgYWNjZXB0cyBwb3N0aW5nIG9mIHByb3NwZWN0cy4K"